import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 7a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M14 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M4 16a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-2"}]]

const IconBrandAsana = createReactComponent('outline', 'brand-asana', 'BrandAsana', __iconNode);

export default IconBrandAsana;